'use strict';
RegExp.escape = function(value) {
	return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
};

String.prototype.toHMS = function () {
	var sec_num = parseInt(this, 10);
	var hours = Math.floor(sec_num / 3600);
	var minutes = Math.floor((sec_num - hours * 3600) / 60);
	var seconds = sec_num - hours * 3600 - minutes * 60;

	return (hours ? hours + 'h ' : '') + (hours || minutes ? minutes + 'm ' : '') + seconds + 's';
};

String.prototype.toHHMMSS = function () {
	var sec_num = parseInt(this, 10);
	var hours = Math.floor(sec_num / 3600);
	var minutes = Math.floor((sec_num - hours * 3600) / 60);
	var seconds = sec_num - hours * 3600 - minutes * 60;

	hours = hours < 10 ? '0' + hours : hours;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	seconds = seconds < 10 ? '0' + seconds : seconds;

	return (hours !== '00' ? hours + ':' : '') + (minutes !== '00' ? minutes + ':' : '') + seconds;
};

String.prototype.ucwords = function() {
	return (this + '').replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function (match) {
		return match.toUpperCase();
	});
};

class Store {
	constructor(options) {
		this.options = options;
	}

	/**
	 * Handles translations in js.
	 *
	 * Variable texts must be present in the options.messages Object
	 * Placeholders must be marked as ==placeholder==
	 *
	 * @param {string}   _variable_name           The variable name
	 * @param {Object}   _vars                    Variable values for expansion
	 *
	 * @return {string}                           Translated string with the filled placeholders ( if any )
	 */

	it(_variable_name, _vars = {}) {
		let variable_name = (_variable_name || '').toUpperCase();
		let vars = _vars || {};
		let placeholders = {};
		let replacement = '';
		let result = this.options.production ? '' : '{' + variable_name + '}';
		const placeholder_regex = /={2}([^=]+)={2}/mig;

		if (this.options.messages[variable_name]) {
			result = this.options.messages[variable_name];
			placeholders = result.match(placeholder_regex);

			for (let i in placeholders) {
				if (Object.prototype.hasOwnProperty.call(placeholders, i)) {
					placeholders[i] = placeholders[i] + '';
					placeholders[i] = placeholders[i].replace(/={2}/gim, '');
					replacement = vars[placeholders[i]] ? vars[placeholders[i]] : '';

					let _rep_regex = new RegExp('==' + (placeholders[i] + '==').replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), 'mig');
					result = result.replace(_rep_regex, replacement);
				}
			}
		}

		return result;
	}

	/**
	 * Format the date from a timestamp. Format type: m/d/y.
	 * Includes a fix on old IEs and wew Safaris where the 'Y-m-d H:i:s' Date format isn't recognized
	 *
	 * @param {string}   date
	 *
	 * @return {string}                 Formatted date by US standard ( m/d/y )
	 */

	format_date(date) {
		let split_date = date.split(/[- :]/),
			format_date = new Date(split_date[0], split_date[1]-1, split_date[2], split_date[3], split_date[4], split_date[5]);

		let year = format_date.getFullYear();
		let month = format_date.getMonth() + 1;
		let day = format_date.getDate();

		month = month < 10 ? '0' + month : month;
		day = day < 10 ? '0' + day : day;

		return `${month}/${day}/${year}`;
	}

	/**
	 * Format the time from a timestamp. Format type: H:i:s.
	 * Includes a fix on old IEs and wew Safaris where the 'Y-m-d H:i:s' Date format isn't recognized
	 *
	 * @param {string}   date
	 *
	 * @return {string}                 Formatted time ( H:i:s )
	 */

	format_time(date) {
		let split_date = date.split(/[- :]/),
			format_date = new Date(split_date[0], split_date[1]-1, split_date[2], split_date[3], split_date[4], split_date[5]);

		let hours = format_date.getHours();
		let minutes = format_date.getMinutes();
		let seconds = format_date.getSeconds();

		hours = hours < 10 ? '0' + hours : hours;
		minutes = minutes < 10 ? '0' + minutes : minutes;
		seconds = seconds < 10 ? '0' + seconds : seconds;

		return `${hours}:${minutes}:${seconds}`;
	}

	/**
	 * Format the date and time from a timestamp. Format type: m/d/y H:i:s.
	 *
	 * @param {string}   date
	 *
	 * @return {string}                 Formatted date and time ( m/d/y H:i:s )
	 */

	format_datetime(date) {
		let _format_date = this.format_date(date);
		let _format_time = this.format_time(date);

		return `${_format_date} ${_format_time}`;
	}

	/**
	 * Format a phone number.
	 *
	 * @param   {string}    phone           Phone number in E.164 format
	 * @return  {string}                    Formatted phone number
	 */

	format_phone(phone) {
		let new_phone = phone.replace(/[^0-9]/gi, '', phone);
		let intl_re = /^\+?(2[07]|2[1-69][0-9]|3[0-469]|3[578][0-9]|4[013-9]|42[0-9]|5[09][0-9]|5[1-8]|6[0-6]|6[7-9][0-9]|7|8[1-46]|8[0578][0-9]|9[0-58]|9[679][0-9])(.*)$/;
		let matches_us = new_phone.match(/^\+?1([2-9][0-8][0-9])([2-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
		let matches_intl = new_phone.match(intl_re);

		if (matches_us && matches_us.length > 2) {
			new_phone = '+1 (' + matches_us[1] + ') ' + matches_us[2] + ' ' + matches_us[3];
		} else if (matches_intl && matches_intl.length > 1) {
			new_phone = '+' + matches_intl[1] + ' ' + matches_intl[2];
		}

		return new_phone;
	}

	/**
	 * Format a monetary value according to a predefined format string.
	 *
	 * @param   {number}     value               The value to format
	 * @param   {boolean}   cents               Format cents if true
	 * @param   {int|null}       rate_precision      Number of digits after the dot.
	 * @param   {object|null}     currency            Currency info Object
	 * @return  {string}                        The formatted value.
	 */

	format_money(value, cents = false, rate_precision= null, currency = null) {
		return this.format_money_str(value, ':symbol:integer:point:decimals:minor_symbol:code', cents, rate_precision, currency);
	}

	/**
	 * Format a monetary value according to a given format string.
	 *
	 * @param   {number}     value               The value to format
	 * @param	{string}    format_string       The format string
	 * @param   {boolean}   cents               Format cents if true
	 * @param   {int|null}       _rate_precision     Number of digits after the dot.
	 * @param   {object|null}     _currency           Currency info Object
	 * @return  {string}                        The formatted value.
	 */

	format_money_str(value, format_string = ':symbol:integer:point:decimals:minor_symbol:code', cents = false, _rate_precision = null, _currency= null) {
		let currency, rate_precision;
		if (typeof this.options.currency !== 'undefined') {
			currency = _currency || this.options.currency;
		} else {
			currency = _currency || {
				code: 'USD',
				symbol: '$',
				minor_symbol: '\u00a2',
				exponent: 2
			};
		}

		if (typeof _rate_precision === 'undefined' || _rate_precision === null) {
			rate_precision = currency.exponent ? currency.exponent : 2;
		} else {
			rate_precision = _rate_precision;
		}

		if (!cents) {
			cents = false;
		}

		value = Math.round(parseFloat(value) * Math.pow(10, rate_precision)) / Math.pow(10, rate_precision);

		const number_parts = (value + '').split('.');
		let components = {
			'code': '',
			'symbol': '',
			'minor_symbol': '',
			'integer': number_parts[0],
			'point': number_parts[1] ? '.' : '',
			'decimals': number_parts[1] ? number_parts[1] : ''
		};

		if (cents) {
			if (currency['minor_symbol'] && !this.options.hide_currency_symbol) {
				components['minor_symbol'] = currency['minor_symbol'];
			} else {
				return this.format_money_str(value / 100, format_string, false, rate_precision, currency);
			}
		} else {
			if (currency['symbol'] && !this.options.hide_currency_symbol) {
				if (components['integer'][0] === '-' && currency['symbol'].length >= 1 && currency['symbol'].length <= 2) {
					components['symbol'] = '-' + currency['symbol'];
					components['integer'] = components['integer'].substr(1);
				} else {
					components['symbol'] = currency['symbol'] + (currency['symbol'].length > 2 ? ' ' : '');
				}
			} else {
				components['code'] = ' ' + currency['code'];
			}
		}

		return format_string.replace(/:(\w+)/g, function(match, contents) {
			return typeof components[contents] !== 'undefined' ? components[contents] : '';
		});
	}

	/**
	 * Build an application-relative URL and encode arguments for query strings.
	 *
	 * @param   {string}      page			Page name, relative to the site root
	 * @param   {object}       parameters			arguments for the query string
	 * @param   {boolean}     absolute		Generate an absolute URL if true
	 * @param   {boolean}     ssl			Generate an SSL URL
	 * @return  {string}					URL
	 */

	url(page= '', parameters = {}, absolute = false, ssl = this.options.is_ssl) {
		let url = '';
		let query_string = '';
		let root_url = this.options.root_url || '';
		let http_host = this.options.http_host || '';

		if (absolute && http_host) {
			url += `${ssl ? 'https' : 'http'}://${http_host}`;
		}
		if (root_url) {
			url += `/${encodeURIComponent(this.trim(decodeURIComponent(root_url), '/'))}`;
		}

		url += '/' + this.trim(page, '/');

		if (parameters) {
			let query_parameters = '';
			for (let parameter_name in parameters) {
				if (Object.prototype.hasOwnProperty.call(parameters, parameter_name)) {
					query_parameters += `&${encodeURIComponent(parameter_name)}=${encodeURIComponent(parameters[parameter_name])}`;
				}
			}
			if (query_parameters) {
				query_string = `?${this.ltrim(query_parameters, '&')}`;
			}
		}

		return url + query_string;
	}

	/**
	 * Escape HTML special characters, for use in templates.
	 *
	 * @param  {string} str     String to be escaped
	 *
	 * @return {string}         HTML Escaped string
	 */

	h(str) {
		str = String(str);
		const escaped = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'\'': '&#39;',
			'"': '&quot;'
		};

		return str.replace(/[&<>'"]/g, function (m) {
			return escaped[m];
		});
	}

	/**
	 * Trim a string. Removes whitespace on start and end of string.
	 *
	 * @param {string}   str           String to be escaped
	 * @param {string}      chars         Extra chars to be escaped
	 *
	 * @return {string}                Trimmed string
	 */

	trim(str, chars) {
		return this.ltrim(this.rtrim(str, chars), chars);
	}

	/**
	 * Trim the start of a string.
	 *
	 * @param {string}   str           String to be escaped
	 * @param {string}      chars         Extra chars to be escaped
	 *
	 * @return {string}                Trimmed string
	 */

	ltrim(str, chars) {
		str = str || '';
		chars = chars || '\\s';

		return str.replace(new RegExp('^[' + chars + ']+', 'g'), '');
	}

	/**
	 * Trim the end of a string.
	 *
	 * @param {string}   str           String to be escaped
	 * @param {string}      chars         Extra chars to be escaped
	 *
	 * @return {string}                Trimmed string
	 */

	rtrim(str, chars) {
		str = str || '';
		chars = chars || '\\s';

		return str.replace(new RegExp('[' + chars + ']+$', 'g'), '');
	}

	/**
	 * Validates a CC Number. Removes any any extra characters and uses the Luhn algorithm to verify the checksum.
	 *
	 * @param {string}        number      CC Number to be checked
	 *
	 * @return {boolean}                  Validity of the CC Number
	 */

	validate_credit_card(number) {
		const formats = [
			['2[2-7]', 16],			// Mastercard
			['5[1-5]', 16],			// Mastercard
			['3[47]', 15],			// American Express
			['6011|64[4-9]|65', 16], // Discover
			['6011|64[4-9]|65', 19], // Discover
			['62', 16],				// UnionPay
			['62', 17],				// UnionPay
			['62', 18],				// UnionPay
			['62', 19],				// UnionPay
			['2131|1800|35', 16],	// JCB
			['4', 13],				// Visa
			['4', 16],				// Visa
			['4', 19]				// Visa
		];
		number = number.replace(/[^0-9]/g, '');
		let _valid = false;
		for (let _i = 0;_i < formats.length;_i++) {
			if (number.length === formats[_i][1] && number.match(new RegExp('^(' + formats[_i][0] + ')')))
				_valid = true;
		}
		if (!_valid) {
			return false;
		}
		// luhn check
		let _parity = number.length % 2;
		let _total = 0;
		for (let _i = 0;_i < number.length;_i++) {
			let _digit = parseInt(number.charAt(_i));
			if (_i % 2 === _parity) {
				_digit *= 2;
				if (_digit > 9)
					_digit -= 9;
			}
			_total += _digit;
		}

		return _total % 10 === 0;
	}

	/**
	 * Validates a Phone number. Removes any any extra characters and removed the international prefix / 0's at the start.
	 *
	 * @param {string}   phone           Phone number to be checked.
	 *
	 * @return {Array}                   Validity of the phone number, followed by the formatted phone no.
	 */

	validate_phone_number(phone) {
		let valid = false;

		phone = phone.replace(/[^0-9]/g, '');
		phone = phone.replace(/^(011|0+)/, '');
		if (phone.length >= 7 && phone.length <= 15) {
			valid = true;
		}

		return [valid, phone];
	}

	/**
	 * Used to easily add the SVG HTML code.
	 *
	 * @param {Array/string}    href              Single / Multiple hrefs for the elements
	 * @param {string}          viewbox           Viewbox for the specific svg. Needed for resizing/displaying on webkit browsers
	 * @param {Array/string}    classes           Single / Multiple classes for the element
	 * @param {Object/string}   css_obj           css styles for the element
	 * @param {Object/string}   attr_obj          attributes for the element
	 * @param {Object/string}   use_fill          Fills for the svg's paths
	 * @param {Object/string}   use_class         Classes for the svg's paths
	 *
	 * @return {string}              HTML code for the required SVG.
	 */

	svg(href, viewbox, classes, css_obj, attr_obj, use_fill, use_class) {
		/* do it the old way - until IE finally dies */
		let _svg = '<svg';
		if (viewbox) {
			_svg += ` viewBox="${viewbox}" `;
		}
		if (css_obj) {
			_svg += ' style="';
			Object.keys(css_obj).forEach(key => {
				_svg += ` ${key}:${css_obj[key]}; `;
			});
			_svg += ' " ';
		}
		if (attr_obj) {
			Object.keys(attr_obj).forEach(key => {
				_svg += ` ${key}="${attr_obj[key]}" `;
			});
		}
		if (Array.isArray(classes)) {
			_svg += ' class="';
			for (let _i=0, _len = classes.length;_i<_len;_i++) {
				_svg += ` ${classes[_i]} `;
			}
			_svg += ' " ';
		} else {
			_svg += ` class="${classes}"`;
		}
		if (Array.isArray(href)) {
			_svg += '>';
			href.forEach(function(element, index) {
				_svg += ` <use xlink:href="#${element}" `;
				if (use_fill && Array.isArray(use_fill)) {
					if (use_fill[index]) {
						_svg += ` fill="url(#${use_fill[index]})" `;
					}
				}
				if (use_class && Array.isArray(use_class)) {
					if (use_class[index]) {
						_svg += ` class="url(#${use_class[index]})" `;
					}
				}
				_svg += '></use>';
			});
		} else {
			_svg += '>';
			_svg += ` <use xlink:href="#${href}" `;
			if (use_fill) {
				if (!Array.isArray(use_fill)) {
					_svg += ` fill="url(#${use_fill})" `;
				}
			}
			if (use_class) {
				if (!Array.isArray(use_class)) {
					_svg += ` fill="url(#${use_class})" `;
				}
			}
			_svg += ' ></use>';
		}
		_svg += '</svg>';

		return _svg;
	}

	loadScript(scriptUrl, custom_attributes) {
		const script = document.createElement('script');
		script.src = scriptUrl;
		if (custom_attributes) {
			Object.keys(custom_attributes).forEach(_k => {
				script.setAttribute(_k, custom_attributes[_k]);
			});
		}
		document.body.appendChild(script);

		return new Promise((res, rej) => {
			script.onload = res;
			script.onerror = rej;
		});
	}
}
